module.exports = __webpack_public_path__ + "static/media/the-i-land.16f0733b.jpg";